import { LOCALE_TYPE } from 'src/types/locale';

const vjwGuideLinkMap = new Map<string, string>([
  [LOCALE_TYPE.TW, 'https://services.digital.go.jp/zh-cmn-hant/visit-japan-web/guide/'],
  [LOCALE_TYPE.HK, 'https://services.digital.go.jp/zh-cmn-hant/visit-japan-web/guide/'],
  [LOCALE_TYPE.CN, 'https://services.digital.go.jp/zh-cmn-hans/visit-japan-web/guide/'],
  [LOCALE_TYPE.EN, 'https://services.digital.go.jp/en/visit-japan-web/guide/'],
  [LOCALE_TYPE.JA, 'https://services.digital.go.jp/visit-japan-web/guide/']
]);

export const getVJWGuideLink = (locale: string | undefined) => {
  if (!locale) return '';
  return vjwGuideLinkMap.get(locale) ?? '';
};
